import React from "react";
import Banner from "./Banner/Banner";
import styles from "./Membership.module.css";
import MentorsProgram from "./MentorsProgram/MentorsProgram";
import AuthorMembersFeatures from "./AuthorMembersFeatures/AuthorMembersFeatures";
import AuthorMembers from "./AuthorMembers/AuthorMembers";
import Institutional from "./Insitutional/Insitutional";
import KnowledgeHub from "./knowledgeHub/knowledgeHub";
import KnowledgehubProgram from "./KnowledgehubProgram/KnowledgehubProgram";

const Mentors = () => {
  return (
    <main className={styles.mentorsPage}>
      <Banner />
      <MentorsProgram />
      <AuthorMembersFeatures />
      <AuthorMembers />
      <Institutional />
      <KnowledgeHub />
      <KnowledgehubProgram />
    </main>
  );
};

export default Mentors;
